class CartDiscountCode {
  constructor() {
    this.selectors = {
      drawer: '.scd__wrapper',
      body: '.scd__body',
      summary: '.scd__summary',
      coupon: '#scd-coupon',
      input: '#scd-coupon [name="discount"]',
      message: '#coupon-messages',
      saveButton: '#scd-coupon .btn-save[data-action="coupon"]',
      notification: '[data-discount-noti]',
      overlay: '.scd__overlay',
    };
    this.storageKey = 'mn-discount-code';
    this.boundApply = this.handleApply.bind(this);
    this.init();
  }

  init() {
    document.addEventListener('click', this.boundApply, true);
  }

  async handleApply(event) {
    const button = event.target.closest(this.selectors.saveButton);
    if (!button) return;

    const coupon = button.closest(this.selectors.coupon);
    const input = coupon?.querySelector('[name="discount"]');
    const code = input?.value?.trim();

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!code) {
      this.showMessage('Introdu un cod de reducere.', 'error');
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    this.showMessage('Se aplica reducerea...', 'info');

    try {
      localStorage.setItem(this.storageKey, code);
      await this.applyDiscount(code);
      await this.refreshCartDrawer();
      await this.emitCartUpdate();
      this.closeCoupon();
      this.showDiscountNotification();
    } catch (error) {
      console.error('[CartDiscountCode] apply error', error);
      this.showMessage('Codul nu a putut fi aplicat. Verifica daca este valid.', 'error');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  async applyDiscount(code) {
    const discountUrl = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
    const response = await fetch(discountUrl, {
      credentials: 'same-origin',
      redirect: 'follow',
    });

    if (!response.ok) {
      throw new Error(`Discount request failed with ${response.status}`);
    }
  }

  async refreshCartDrawer() {
    const response = await fetch('/cart?section_id=cart-drawer', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error(`Cart section request failed with ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextBody = doc.querySelector(this.selectors.body);
    const nextSummary = doc.querySelector(this.selectors.summary);
    const currentDrawer = document.querySelector(this.selectors.drawer);
    const currentBody = currentDrawer?.querySelector(this.selectors.body);
    const currentSummary = currentDrawer?.querySelector(this.selectors.summary);

    if (nextBody && currentBody) {
      currentBody.replaceWith(nextBody);
    }

    if (nextSummary && currentSummary) {
      currentSummary.replaceWith(nextSummary);
    }
  }

  async emitCartUpdate() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
    });

    if (!response.ok) return;

    const cart = await response.json();
    window._ThemeEvent?.emit?.('ON_CART_UPDATE', cart);
    window._ThemeEvent?.emit?.('ON_FOX_CART_UPDATE', cart);
    document.dispatchEvent(new CustomEvent('cartUpdated', { detail: cart }));
  }

  closeCoupon() {
    const coupon = document.querySelector(this.selectors.coupon);
    const overlay = document.querySelector(this.selectors.overlay);

    coupon?.classList.remove('open');
    overlay?.classList.remove('open');
  }

  showDiscountNotification() {
    document.querySelectorAll(this.selectors.notification).forEach((node) => {
      node.style.display = 'inline';
      node.classList.remove('hidden');
    });
  }

  showMessage(text, type) {
    const message = document.querySelector(this.selectors.message);
    if (!message) return;

    message.innerHTML = `<p class="cart-discount-code-message cart-discount-code-message--${type}">${this.escapeHtml(text)}</p>`;
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

if (!window.__cartDiscountCode) {
  window.__cartDiscountCode = new CartDiscountCode();
}
